export default function BookV2(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none" {...props}>
			<path
				d="M2.5 15.2758V5.11559C2.5 3.39664 3.9964 2 5.83813 2H15.1619C17.0036 2 18.5 3.39664 18.5 5.11559V15.2758C18.5 16.9947 17.0036 18.3914 15.1619 18.3914H5.83813C3.9964 18.3914 2.5 16.9947 2.5 15.2758Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12.8137 6.09003C12.2152 5.46077 11.371 5.1001 10.4962 5.1001C10.4962 5.1001 10.4962 5.1001 10.4885 5.1001C9.66744 5.1001 8.86936 5.43775 8.28614 6.01329C7.70293 6.58883 7.37296 7.39458 7.37296 8.21569C7.37296 8.64542 7.72595 8.99842 8.15569 8.99842C8.58543 8.99842 8.93842 8.64542 8.93842 8.22336C8.93842 7.36389 9.63674 6.66557 10.4962 6.66557C10.9413 6.66557 11.371 6.84974 11.678 7.17204C11.9312 7.43295 12.0694 7.79362 12.054 8.15429C12.0387 8.46892 12.0233 8.7682 11.0257 9.76581C10.3427 10.4488 9.72116 11.1318 9.63674 12.0142C9.59838 12.444 9.90533 12.82 10.3427 12.866C10.3658 12.866 10.3888 12.866 10.4118 12.866C10.8108 12.866 11.1485 12.5591 11.1869 12.16C11.2176 11.8301 11.5859 11.408 12.1231 10.8632C13.3279 9.65837 13.5658 9.03679 13.6118 8.23103C13.6578 7.44063 13.3662 6.68091 12.806 6.09003H12.8137Z"
				fill="currentColor"
			/>
			<path
				d="M10.3964 13.4878C9.89756 13.4878 9.49852 13.8868 9.49852 14.3856C9.49852 14.8844 9.89756 15.2835 10.3964 15.2835C10.8952 15.2835 11.2942 14.8768 11.2942 14.3856C11.2942 13.8945 10.8952 13.4878 10.3964 13.4878Z"
				fill="currentColor"
			/>
		</svg>
	);
}
